import { academyCustomCSS } from '~/constants/academyCustomCSS';
import CountingBadge from './counting-badge';

const SubMenuLink = ({ link, linkText, isActive, badgeCount, subnavActiveLinkColor }) => (
  <li role="none">
    <a href={link} className={`${academyCustomCSS.tabBar.tab} ${isActive ? 'active' : ''}`} role="menuitem">
      {linkText}
      {!!badgeCount && <CountingBadge badgeCount={badgeCount} subnavActiveLinkColor={subnavActiveLinkColor} />}
    </a>
  </li>
);

export default SubMenuLink;
